import { render, staticRenderFns } from "./ProductSpecificationTable.vue?vue&type=template&id=7ee2538d&scoped=true"
import script from "./ProductSpecificationTable.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee2538d",
  null
  
)

export default component.exports